export const createHeadline = ({ headlineTitle }) => headlineTitle || 'Personal Styling';
